// extracted by mini-css-extract-plugin
export default {"introText":"IntroCard_introText__mV2uU","fadeIn":"IntroCard_fadeIn__F+3XA"};